import Nav from './IndexNavigation';
import LoginModal from './LoginModal';

export default {
    Nav,
    LoginModal
}



// WEBPACK FOOTER //
// ./containers/Indexes/index.js